/// Toda rolagem conduzida pelo sistema usa a mesma animação — a do navegador —, para que ir até um
/// campo tenha a velocidade de voltar ao topo. Quem pediu ao sistema operacional menos movimento
/// recebe o salto direto.
export function scrollMotion(): ScrollBehavior {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

/// Leva a tela até o campo e só então põe o cursor nele. Focar antes faria o navegador saltar até
/// o campo — no celular, abrindo o teclado no meio da animação.
export function revealField(field: HTMLElement) {
  const focus = () => field.focus({ preventScroll: true });
  const box = field.getBoundingClientRect();
  if (box.top >= 0 && box.bottom <= window.innerHeight) {
    focus();
    return;
  }
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    document.removeEventListener('scrollend', finish, true);
    window.clearTimeout(fallback);
    focus();
  };
  // Nem todo navegador avisa o fim da rolagem; o prazo cobre a animação mais longa.
  const fallback = window.setTimeout(finish, 1000);
  document.addEventListener('scrollend', finish, true);
  field.scrollIntoView({ behavior: scrollMotion(), block: 'center' });
}
